// removed by extract-text-webpack-plugin
module.exports = {"base":"_29IhgP4OIC9SLHvANH1ngG"};


//////////////////
// WEBPACK FOOTER
// ./src/components/OasisDontWrapAllEther.scss
// module id = 1310
// module chunks = 0